import { Link } from "@/components/common/Link";
export default function InstagramPromoStrip() {
  return <section id="instagrampromostrip" className="bg-[#1A1A1A] py-16 md:py-24 px-6 flex justify-center items-center text-center">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-[var(--color-gold)] tracking-wide uppercase leading-tight">
          More deals coming. Follow{" "}
          <Link to="https://instagram.com/sultanigrill" newTab className="underline decoration-2 underline-offset-8 hover:text-white transition-colors duration-300">
            @sultanigrill
          </Link>{" "}
          on Instagram to stay updated.
        </h2>
      </div>
    </section>;
}